import { render, staticRenderFns } from "./ManageLink.vue?vue&type=template&id=91656388&"
import script from "./ManageLink.vue?vue&type=script&lang=js&"
export * from "./ManageLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports